import { getLanguageAndRegion, ALIASES_FOR_REGIONS, DEFAULT_LANGUAGE_BY_REGION, DEFAULT_REGION, REGION_ALIASES } from '@lemonade-hq/lemonation';
import { typedKeys } from '@lemonade-hq/ts-helpers';
import uniqBy from 'lodash/uniqBy';
import { LOCALE_URL_PREFIXES, ALL_ROUTES } from '../config/routes.esm.js';

function _array_like_to_array(arr, len) {
    if (len == null || len > arr.length) len = arr.length;
    for(var i = 0, arr2 = new Array(len); i < len; i++)arr2[i] = arr[i];
    return arr2;
}
function _array_with_holes(arr) {
    if (Array.isArray(arr)) return arr;
}
function _array_without_holes(arr) {
    if (Array.isArray(arr)) return _array_like_to_array(arr);
}
function _define_property(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function _iterable_to_array(iter) {
    if (typeof Symbol !== "undefined" && iter[Symbol.iterator] != null || iter["@@iterator"] != null) return Array.from(iter);
}
function _iterable_to_array_limit(arr, i) {
    var _i = arr == null ? null : typeof Symbol !== "undefined" && arr[Symbol.iterator] || arr["@@iterator"];
    if (_i == null) return;
    var _arr = [];
    var _n = true;
    var _d = false;
    var _s, _e;
    try {
        for(_i = _i.call(arr); !(_n = (_s = _i.next()).done); _n = true){
            _arr.push(_s.value);
            if (i && _arr.length === i) break;
        }
    } catch (err) {
        _d = true;
        _e = err;
    } finally{
        try {
            if (!_n && _i["return"] != null) _i["return"]();
        } finally{
            if (_d) throw _e;
        }
    }
    return _arr;
}
function _non_iterable_rest() {
    throw new TypeError("Invalid attempt to destructure non-iterable instance.\\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function _non_iterable_spread() {
    throw new TypeError("Invalid attempt to spread non-iterable instance.\\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function _object_spread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            _define_property(target, key, source[key]);
        });
    }
    return target;
}
function ownKeys(object, enumerableOnly) {
    var keys = Object.keys(object);
    if (Object.getOwnPropertySymbols) {
        var symbols = Object.getOwnPropertySymbols(object);
        if (enumerableOnly) {
            symbols = symbols.filter(function(sym) {
                return Object.getOwnPropertyDescriptor(object, sym).enumerable;
            });
        }
        keys.push.apply(keys, symbols);
    }
    return keys;
}
function _object_spread_props(target, source) {
    source = source != null ? source : {};
    if (Object.getOwnPropertyDescriptors) {
        Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
    } else {
        ownKeys(Object(source)).forEach(function(key) {
            Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
        });
    }
    return target;
}
function _sliced_to_array(arr, i) {
    return _array_with_holes(arr) || _iterable_to_array_limit(arr, i) || _unsupported_iterable_to_array(arr, i) || _non_iterable_rest();
}
function _to_consumable_array(arr) {
    return _array_without_holes(arr) || _iterable_to_array(arr) || _unsupported_iterable_to_array(arr) || _non_iterable_spread();
}
function _unsupported_iterable_to_array(o, minLen) {
    if (!o) return;
    if (typeof o === "string") return _array_like_to_array(o, minLen);
    var n = Object.prototype.toString.call(o).slice(8, -1);
    if (n === "Object" && o.constructor) n = o.constructor.name;
    if (n === "Map" || n === "Set") return Array.from(n);
    if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _array_like_to_array(o, minLen);
}
var PageTarget;
(function(PageTarget) {
    PageTarget["SELF"] = "_self";
    PageTarget["BLANK"] = "_blank";
})(PageTarget || (PageTarget = {}));
// internal api
function generateLocalizedRoutes(routes, transformer) {
    return routes.reduce(function(localizedRoutes, route) {
        return _object_spread_props(_object_spread({}, localizedRoutes), _define_property({}, route.name, transformer(route)));
    }, {});
}
function generatePageRoutes(routes, transformer) {
    return routes.reduce(function(pageRoutes, route) {
        return _to_consumable_array(pageRoutes).concat([
            transformer(route)
        ]);
    }, []);
}
function getTransformForClientFormat(baseUrl) {
    var internalPages = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : [], externalPages = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : {};
    return function(param) {
        var name = param.name, langPrefix = param.langPrefix, regionPrefix = param.regionPrefix, path = param.path;
        var host = internalPages.includes(name) ? "" : baseUrl;
        var transformed = "".concat(path);
        if (regionPrefix != null && langPrefix != null) {
            transformed = "".concat(regionPrefix, "/").concat(langPrefix, "/").concat(path);
        } else if (regionPrefix != null) {
            transformed = "".concat(regionPrefix, "/").concat(path);
        }
        // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
        return externalPages[name] != null ? externalPages[name] : "".concat(host, "/").concat(transformed);
    };
}
function transformToServerFormat(param) {
    var regionPrefix = param.regionPrefix, langPrefix = param.langPrefix, path = param.path;
    var regionString = regionPrefix !== null && regionPrefix !== void 0 ? regionPrefix : "";
    var regionSegment = regionPrefix != null && regionPrefix.length > 0 ? "/:region(".concat(regionString, ")") : "";
    var langSegment = langPrefix != null && langPrefix.length > 0 ? "/:lang(".concat(langPrefix, ")") : "";
    var pathSegment = path.length > 0 ? "/".concat(path) : "";
    var result = "".concat(regionSegment).concat(langSegment).concat(pathSegment);
    return result.length === 0 ? "/" : result;
}
function generateRoutes(routeConfig, region, lang, regionPrefix, langPrefix) {
    return typedKeys(routeConfig).reduce(function(routes, name) {
        var path = routeConfig[name];
        var lowerCasedRegionPrefix = regionPrefix === null || regionPrefix === void 0 ? void 0 : regionPrefix.toLowerCase();
        return path != null ? _to_consumable_array(routes).concat([
            {
                name: name,
                path: path,
                region: region,
                lang: lang,
                regionPrefix: lowerCasedRegionPrefix,
                langPrefix: langPrefix
            }
        ]) : routes;
    }, []);
}
function generateRoutesList(fullRoutesConfig) {
    var result = [];
    Object.keys(fullRoutesConfig).forEach(function(r) {
        var region = r;
        if (region === "default") {
            result = result.concat(generateRoutes(fullRoutesConfig[region], DEFAULT_REGION, DEFAULT_LANGUAGE_BY_REGION[DEFAULT_REGION]));
        } else {
            typedKeys(fullRoutesConfig[region]).forEach(function(l) {
                var lang = l;
                var routesConfigForLocale = fullRoutesConfig[region];
                if (lang === "default") {
                    result = result.concat(generateRoutes(routesConfigForLocale[lang], region, DEFAULT_LANGUAGE_BY_REGION[region], REGION_ALIASES[region]));
                } else {
                    var langRoutes = _to_consumable_array(generateRoutes(routesConfigForLocale[lang], region, lang, region, lang)).concat(_to_consumable_array(generateRoutes(routesConfigForLocale.default, region, lang, region, lang)));
                    result = result.concat(uniqBy(langRoutes, function(route) {
                        return route.name;
                    }));
                }
            });
        }
    });
    return result;
}
var ROUTES_LIST = generateRoutesList(ALL_ROUTES);
// public api
// returns a list of all the Express/Koa paths with constraints for the path argument for the given page.
// e.g. for the `imprint` page:
// ["/:region(de)/impressum","/:region(de)/:lang(en)/imprint"]
function getServerRoutesForPage(name, activeRegions) {
    var filteredRoutes = ROUTES_LIST.filter(function(route) {
        var isExistingPage = route.name === name;
        var isActivePage = activeRegions.includes(route.region);
        return isExistingPage && isActivePage;
    });
    return generatePageRoutes(filteredRoutes, transformToServerFormat);
}
// returns a list of the url-space that should respond with 404 for all active locales
function getServer404RoutesFor() {
    var localesRoutePrefixesMapping = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : LOCALE_URL_PREFIXES;
    return typedKeys(localesRoutePrefixesMapping).map(function(locale) {
        var path = localesRoutePrefixesMapping[locale];
        if (path === "") {
            return "*";
        } else {
            var region = path === null || path === void 0 ? void 0 : path.split("/")[0];
            var lang = path === null || path === void 0 ? void 0 : path.split("/")[1];
            if (lang != null) {
                return "/:region(".concat(region, ")/:lang(").concat(lang, ")/*");
            } else {
                return "/:region(".concat(region, ")/*");
            }
        }
    });
}
function getRoutesForClient(region, lang, baseUrl) {
    var internalPages = arguments.length > 3 && arguments[3] !== void 0 ? arguments[3] : [], externalPages = arguments.length > 4 && arguments[4] !== void 0 ? arguments[4] : {};
    var filteredRoutes = ROUTES_LIST.filter(function(route) {
        return route.region === region && route.lang === lang;
    });
    var localizedRoutes = generateLocalizedRoutes(filteredRoutes, getTransformForClientFormat(baseUrl, internalPages, externalPages));
    return _object_spread_props(_object_spread({}, localizedRoutes), {
        host: baseUrl
    });
}
function getRouteForLocale(name, locale) {
    var _getLanguageAndRegion = _sliced_to_array(getLanguageAndRegion(locale), 2), lang = _getLanguageAndRegion[0], region = _getLanguageAndRegion[1];
    var result = ROUTES_LIST.find(function(route) {
        return route.region === region && route.lang === lang && route.name === name;
    });
    var prefix = LOCALE_URL_PREFIXES[locale];
    return result != null ? prefix.length === 0 && result.path.length === 0 ? "/" : "".concat(prefix.length > 0 ? "/".concat(prefix) : "").concat(result.path.length > 0 ? "/" : "").concat(result.path) : undefined;
}
function urlWithPreventRedirect(fullUrl) {
    var _fullUrl_split;
    var _ref = _sliced_to_array((_fullUrl_split = fullUrl === null || fullUrl === void 0 ? void 0 : fullUrl.split("?")) !== null && _fullUrl_split !== void 0 ? _fullUrl_split : [
        "",
        ""
    ], 2), url = _ref[0], search = _ref[1];
    var searchParams = new URLSearchParams(search);
    searchParams.set("f", "1");
    return "".concat(url, "?").concat(searchParams.toString());
}
function getRegionForAlias(alias) {
    return ALIASES_FOR_REGIONS[alias];
}

export { PageTarget, getRegionForAlias, getRouteForLocale, getRoutesForClient, getServer404RoutesFor, getServerRoutesForPage, urlWithPreventRedirect };
